import styled from 'styled-components';

import { pxToRem } from 'utils/scss';

export const WrapperChart = styled.div`
  position: relative;
  height: 100%;
  min-width: 100%;
  width: ${props => (!props.width ? '100%' : pxToRem(props.width))};
`;

export const VerticalLabel = styled.div`
  position: absolute;
  transform: rotate(-90deg)
    translateX(
      ${props => (props.isBiggerChart ? pxToRem('180px') : pxToRem('120px'))}
    )
    translateY(${pxToRem('-20px')}) scale(4);
  z-index: 9;
`;

export const ChartWrapper = styled.div`
  position: relative;
  z-index: 10;
  height: 100%;
`;
